import { Sportsbook } from "../../contracts";
import { ConnectionWrapper } from "../ConnectionWrapper";
export const connectionFactory = (meta) => {
    return {
        createEventsFromTopLeaguesBySportId(cbHandler) {
            return new ConnectionWrapper(meta, cbHandler, Sportsbook.queryBuilder.getEventsFromTopLeaguesBySportId);
        },
        createEventsBySportId(cbHandler) {
            return new ConnectionWrapper(meta, cbHandler, Sportsbook.queryBuilder.getEventsBySportId);
        },
        createEventsByEventId(cbHandler) {
            return new ConnectionWrapper(meta, cbHandler, Sportsbook.queryBuilder.getEventsByEventId);
        },
        createEventsByRegionId(cbHandler) {
            return new ConnectionWrapper(meta, cbHandler, Sportsbook.queryBuilder.getEventsByRegionIdAndSportId);
        },
        createEventsByLeagueId(cbHandler) {
            return new ConnectionWrapper(meta, cbHandler, Sportsbook.queryBuilder.getEventsByLeagueId);
        },
        createEventsByCouponId(cbHandler) {
            return new ConnectionWrapper(meta, cbHandler, Sportsbook.queryBuilder.getEventsByCouponId);
        },
        createEventsGoingLive(cbHandler) {
            return new ConnectionWrapper(meta, cbHandler, Sportsbook.queryBuilder.getGoingLiveEvents);
        }
    };
};
//# sourceMappingURL=connectionFactory.js.map